var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEndurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8m-8 0a8 8 0 1 1 16 0a8 8 0 1 1 -16 0",
    fill: "#FEEDEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_endurance)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.5H5.5V6.205L11.295 12L12 11.295L6.205 5.5H9.5V4.5H4.5V9.5Z",
    fill: "#F24C3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_endurance"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEndurance);
export default __webpack_public_path__ + "static/media/ic_endurance.abeff164c8a4d63669e4da54d6388ab7.svg";
export { ForwardRef as ReactComponent };